<template>
  <div class="content if-profile">
    <MPHeader v-if="headerData" :headerData="this.headerData" />
    <div class="md-layout ratios-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <div class="md-transparent finanical-report-messages demographics blue-tbl">
          <nav-tabs-card class="p-0 m-0">
            <template slot="content">
              <div class="md-layout">
                <md-card class="if_card">
                  <md-card-header>
                    Market Area Demographics - 2020 American Community Survey
                    <md-button v-if="isRingAnalysis && !this.$route.path.includes('sample')"
                      class="md-button md-info btn-sm md-theme-default" @click="isModal = true">
                      <span>Add 3-Ring Analysis</span>
                    </md-button>

                    <md-button v-if="!isRingAnalysis && !this.$route.path.includes('sample')"
                      class="md-button md-info btn-sm md-theme-default" @click="download3ring">
                      <span>Download 3-Ring PDF</span>
                    </md-button>
                  </md-card-header>
                  <md-card-content v-if="isRingAnalysis">
                    <div class="md-layout-item md-medium-size-100 md-size-100 p-4">
                      <ul class="favorite-list companis-list-tabl competitors-list"
                        v-if="Object.values(demographics).length">
                        <li v-for="(categoryData, category) in demographics" :key="category"
                          class="favorite-list-item map-content px-4">
                          <collapse :collapse="[category]" icon="keyboard_arrow_down" color-collapse="white" value="left"
                            :active="true">
                            <template :slot="`md-collapse-pane-1`">
                              <md-card-content>
                                <!-- <div class="md-layout"> -->
                                <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                  <md-table v-for="(table, index) in categoryData" :key="index + '_category'"
                                    table-header-color="blue" class="collapse_table">
                                    <md-table-row v-for="(item, name) in table" :key="name + '_each'">
                                      <md-table-cell class="md-table-side-label">{{ name }}</md-table-cell>
                                      <md-table-cell v-for="(key, i) in item" :key="key + i + name">{{ key }}
                                      </md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                                <!-- </div> -->
                              </md-card-content>
                            </template>
                          </collapse>
                        </li>
                      </ul>
                    </div>
                  </md-card-content>
                  <md-card-content v-else>
                    <div class="md-layout-item md-medium-size-100 md-size-100 p-4">
                      <ul class="favorite-list companis-list-tabl competitors-list">
                        <li v-for="(tableData, title) in demographics" :key="title"
                          class="favorite-list-item map-content px-4">
                          <collapse :collapse="[title]" icon="keyboard_arrow_down" color-collapse="white" value="left"
                            :active="true">
                            <template :slot="`md-collapse-pane-1`">
                              <md-card-content>
                                <!-- <div class="md-layout"> -->
                                <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                  <md-table table-header-color="blue" class="collapse_table">
                                    <md-table-row>
                                      <md-table-cell class="md-table-side-label"></md-table-cell>
                                      <md-table-cell v-if="demog_3ring[Object.keys(demog_3ring)[0]]" colspan="2"
                                        class="md-table-side-label font-titles-demog">
                                        <h4>MARKET AREA</h4>
                                      </md-table-cell>
                                      <md-table-cell
                                        v-if="Object.keys(demog_3ring)[2] && demog_3ring[Object.keys(demog_3ring)[2]]"
                                        colspan="6" class="md-table-side-label font-titles-demog-last-el">
                                        <h4>3-RINGS</h4>
                                      </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                      <md-table-cell class="md-table-side-label"></md-table-cell>
                                      <md-table-cell class="md-table-side-label"></md-table-cell>
                                      <md-table-cell class="md-table-side-label"></md-table-cell>
                                      <md-table-cell v-if="demog_3ring[Object.keys(demog_3ring)[0]]" colspan="2"
                                        class="md-table-side-label font-titles-demog">
                                        Primary Radius
                                        <br />
                                        ({{ Object.keys(demog_3ring)[0] }} Miles)
                                      </md-table-cell>
                                      <md-table-cell v-if="demog_3ring[Object.keys(demog_3ring)[1]]" colspan="2"
                                        class="md-table-side-label font-titles-demog">
                                        Second Radius
                                        <br />
                                        ({{ Object.keys(demog_3ring)[1] }} Miles)
                                      </md-table-cell>
                                      <md-table-cell
                                        v-if="Object.keys(demog_3ring)[2] && demog_3ring[Object.keys(demog_3ring)[2]]"
                                        colspan="2" class="md-table-side-label font-titles-demog-last-el">
                                        Third Radius
                                        <br />
                                        ({{ Object.keys(demog_3ring)[2] }} Miles)
                                      </md-table-cell>
                                    </md-table-row>

                                    <template v-for="(data, i) in tableData">

                                      <md-table-row v-for="(column, index) in data" :key="i + index + '_each'">
                                        <md-table-cell class="md-table-side-label">{{
                                          index
                                        }}
                                        </md-table-cell>

                                        <md-table-cell class="font-data-demog">
                                          <div v-if="newMarketAreaData">
                                            {{
                                              newMarketAreaData[checkTitle(index)][0].value[0]
                                            }}
                                          </div>
                                        </md-table-cell>
                                        <md-table-cell class="font-data-demog">
                                          <div v-if="newMarketAreaData">
                                            {{
                                              newMarketAreaData[checkTitle(index)][0].value[1]
                                            }}
                                          </div>
                                        </md-table-cell>

                                        <md-table-cell v-if="newDemog3Ring[0]" class="font-data-demog">{{
                                          newDemog3Ring[0][checkTitle(index)]
                                        }}</md-table-cell>
                                        <md-table-cell v-if="newDemog3Ring[0]" class="font-data-demog">{{
                                          newDemog3Ring[0][checkTitle(index) + ' Percent']
                                        }}
                                        </md-table-cell>

                                        <md-table-cell v-if="newDemog3Ring[1]" class="font-data-demog">{{
                                          newDemog3Ring[1][checkTitle(index)]
                                        }}</md-table-cell>
                                        <md-table-cell v-if="newDemog3Ring[1]" class="font-data-demog">{{
                                          newDemog3Ring[1][checkTitle(index) + ' Percent']
                                        }}
                                        </md-table-cell>

                                        <md-table-cell v-if="newDemog3Ring[2]" class="font-data-demog">{{
                                          newDemog3Ring[2][checkTitle(index)]
                                        }}</md-table-cell>
                                        <md-table-cell v-if="newDemog3Ring[2]" class="font-data-demog">{{
                                          newDemog3Ring[2][checkTitle(index) + ' Percent']
                                        }}
                                        </md-table-cell>

                                      </md-table-row>
                                    </template>
                                  </md-table>
                                </div>
                                <!-- </div> -->
                              </md-card-content>
                            </template>
                          </collapse>
                        </li>
                      </ul>
                    </div>
                  </md-card-content>
                </md-card>


                <md-card class="if_card">
                  <md-card-header>Competitive Market Narrative</md-card-header>
                  <md-card-content>
                    <div class="extra_space">
                      <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div> -->
                      <!-- <h4 class="Performance Scores">
                            Competitive Market Narrative
                      </h4>-->
                      <p>
                        {{ cmnText.demographics }}
                      </p>
                    </div>
                  </md-card-content>
                </md-card>
                <md-card class="if_card">
                  <md-card-header>Demographics</md-card-header>
                  <md-card-content>
                    <div class="extra_space">
                      <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div> -->
                      <!-- <h4 class="Performance Scores">
                            Competitive Market Narrative
                      </h4>-->
                      <p>
                        Population demographics are applied from the Census Bureau's American Community Survey.
                        Data for zip-county-metro-state and US markets are applied directly. Demographic totals for
                        radius-based markets are applied at the level of aggregated zip codes which are co-joined to
                        the selected market radius. Elements of this data are also integrated into our Sales per Person
                        and Sales
                        per Household calculations displayed on the Penetration>Table tab.
                      </p>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
    <div class="prospect_content">
      <modal v-if="isModal" @close="isModal = false" class="demographics-modal">
        <template slot="header">
          <button type="button" class="close_btn" @click="isModal = false">
            <md-icon>clear</md-icon>
          </button>
        </template>
        <template slot="body">
          <form action class="form_grp">
            <label class="md-layout-item md-size-25 md-form-label">Input a market center-point address and zip
              code:</label>
            <div class="md-layout spacing">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="addressModel" placeholder="Address" />
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="zipCodeModel" placeholder="ZIP" />
                </md-field>
              </div>
            </div>
          </form>
          <form action class="form_grp">
            <label class="md-layout-item md-size-25 md-form-label">Input up to three radius values in miles (maximum 100
              miles):</label>
            <div class="md-layout spacing">
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="radius1Model" placeholder="Primary Radius" />
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="radius2Model" placeholder="Second Radius" />
                </md-field>
              </div>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="radius3Model" placeholder="Third Radius" />
                </md-field>
              </div>
            </div>
          </form>
          <div class="field_wpr">
            <div class="ml-7 md-layout">
              <md-button @click="isModal = false" class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">
                Cancel</md-button>
              <md-button @click="analysis()" class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Add
              </md-button>
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal, Collapse } from '@/components';
import { NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MPHeader from './MPHeader';
import axios from 'axios';
export default {
  components: {
    NavTabsCard,
    Collapse,
    MPHeader,
    Modal,
  },
  props: ['headerData'],
  data() {
    return {
      isModal: false,
      newDemog3Ring: {},
      showDialog: false,
      demographicsData: [],
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
      filtered_covid_info: [],
      filtered_covid_change_info: [],
      addressModel: null,
      zipCodeModel: null,
      radius1Model: null,
      radius2Model: null,
      radius3Model: null,
      isRingAnalysis: false,
      allRingAnalysisFieldsFilled: false,
      tableDemog3Ring: null,
      newMarketAreaData: null,
    };
  },
  computed: {
    ...mapState({
      demographics: (state) => state.user.industryProfile.data['demographics'],
      demog_3ring: (state) => state.user.industryProfile['demog_3ring'],
      years: (state) => state.user.industryProfile.years,
      release_years: (state) =>
        state.user.industryProfile.general.release_years,
      ownership: (state) => state.user.industryProfile.data['ownership'],
      cessation: (state) => state.user.industryProfile.data['cessation'],
      chartData: (state) =>
        state.user.industryProfile.charts.test['Cessation'][0],
      salesEmpSales: (state) =>
        state.user.industryProfile.data['salesEmpSales'],
      salesEmpCols: (state) => state.user.industryProfile['salesEmpCols'],
      salesEmpEmployment: (state) =>
        state.user.industryProfile.data['salesEmpEmployment'],
      tableCompetitors: (state) =>
        state.user.industryProfile.data['competitors'],
      bznaics_code: (state) => state.user.industryProfile.general.bznaics,
      sector_name: (state) => state.user.industryProfile.general.sector,
      industry_title: (state) => state.user.industryProfile.general.industry,
      release_display: (state) =>
        state.user.industryProfile.general['release_display'],
      update_month: (state) => state.user.industryProfile.updateMonth,
      display_area: (state) =>
        state.user.industryProfile.general.area_display_name,
      marketVolume: (state) => state.user.industryProfile.data['marketVolume'],
      marketShare: (state) => state.user.industryProfile.data['marketShare'],
      annualSales: (state) => state.user.industryProfile.data['annualSales'],
      annualSalesCols: (state) => state.user.industryProfile['annualSalesCols'],
      penetration: (state) => state.user.industryProfile.data['penetration'],
      employment: (state) => state.user.industryProfile.data['employment'],
      productivity: (state) =>
        state.user.industryProfile.data['productivityValues'],
      startupPerformance: (state) =>
        state.user.industryProfile.data['startupsValues'],
      startupRates: (state) => state.user.industryProfile.data['startupsIndex'],
      covid: (state) => state.user.industryProfile.data['covid'],
      covidColumns: (state) => state.user.industryProfile.data['covidColumns'],
      covidChange: (state) => state.user.industryProfile.data['covidChange'],
      covidChangeColumns: (state) =>
        state.user.industryProfile.data['covidChangeColumns'],
      cmnText: (state) => state.user.cmnText,
    }),
    getCsvData() {
      let csvData = [
        ['Bizminer Local Industry Market Report'],
        [this.bznaics_code, this.industry_title],
        ['Sector: ' + this.sector_name],
        [this.display_area],
        [
          'Data Time Series',
          this.release_years.toString() + '-' + this.update_month,
        ],
        ['Update Month', this.update_month],
        [''],
      ];
      csvData.push(['Industry Population Analyzed'], ['as of:', this.years]);
      this.filtered_population.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Annual Industry Market Volume($)'],
        ['as of:', this.years]
      );
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === 'string' && k.includes('.')) {
            e[i] = k.replace(/\./g, '');
          }
        });
        csvData.push(e);
      });
      csvData.push([''], ['Share(%)'], ['', this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], [''], ['Average Annual Sales']);
      csvData.push(['', this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Rank'], ['as of:', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Market Penetration ($)']);
      csvData.push(['', this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        [
          'To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ]
      );
      csvData.push([''], ['']);
      csvData.push(['Employment', this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Market Volume by Employment Class', this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Percent Market Volume by Employment Class', this.years]
      );
      this.filtered_market_percent_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Sales by Employment Class', this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Establishments by Employment Class', this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Total Employment by Class', this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Employment by Class', this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Productivity']);
      csvData.push(['Annual Sales per Employee', this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Average Annual Wage', this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Rent per Employee', this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Productivity Indices (%)', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Startup Activity and Performance']);
      csvData.push(['', this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], [''], ['']);
      csvData.push(
        [
          'To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ],
        [''],
        [''],
        [''],
        [''],
        ['Cessation Rates (2019-2020)'] // TODO: make this automatic.
      );
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Ownership/Consolidation Trends', this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Market Area Demographic Highlights']);
      csvData.push([
        '(based on zip codes co-joined with your market radius) (2015)',
      ]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        });
        csvData.push(['']);
      });
      csvData.push([''], ['COVID IMPACT'], ['Month-to-Month Employment-Sales']);
      csvData.push(['', this.covidColumns]);
      this.filtered_covid_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['% Change from Dec-19']);
      csvData.push(['', this.covidChangeColumns]);
      this.filtered_covid_change_info.forEach((e, i) => {
        csvData.push(e);
      });
      return csvData;
    },
  },

  mounted() {

    let me = this;
    let populationData = Object.entries(this.tableCompetitors).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    populationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_population.push(r);
    });

    let marketVolume = Object.entries(this.marketVolume).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    marketVolume.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let modifiedArr = [];
    marketVolume.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      modifiedArr.push(r);
    });
    modifiedArr.forEach((el) => {
      let modified = el.map(function (el) {
        if (typeof el === 'string' && el.includes(',')) {
          return el.replace(/,/g, '.');
        }
        return el;
      });
      this.filtered_market_volume.push(modified);
    });
    let marketShare = Object.entries(this.marketShare).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    marketShare.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_market_share.push(r);
    });
    this.filtered_market_share = this.filtered_market_share.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let tableAnnual = Object.entries(this.annualSales).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    tableAnnual.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    tableAnnual.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_annual_sales.push(r);
    });
    this.filtered_annual_sales = this.filtered_annual_sales.filter(
      (item, index) => {
        if (!item.includes('Your Firm')) {
          return item;
        }
      }
    );
    let penetrationData = Object.entries(this.penetration).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    penetrationData.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    penetrationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_penetration.push(r);
    });
    let employmentData = Object.entries(this.employment).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    employmentData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_employment.push(r);
    });
    this.filtered_employment = this.filtered_employment.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let marketVolumeByClass = Object.entries(
      this.salesEmpSales.marketVolume
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_by_class.push(b);
    });
    let marketPercentVolumeByClass = Object.entries(
      this.salesEmpSales.percentMarket
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketPercentVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_percent_by_class.push(b);
    });
    let averageSaleByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageSaleByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_sale_by_class.push(b);
    });
    let establishmentByClass = Object.entries(
      this.salesEmpEmployment.establishments
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      establishmentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_establishment_by_class.push(b);
    });
    let totalEmploymentByClass = Object.entries(
      this.salesEmpEmployment.total
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      totalEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_total_employment_by_class.push(b);
    });
    let averageEmploymentByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_employment_by_class.push(b);
    });
    let annualSalesPerEmployee = Object.entries(
      this.productivity.spe
    ).map(([name, data]) => ({ name, dates: data }));
    annualSalesPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    annualSalesPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_annual_sales_per_employee.push(r);
    });
    this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let averageAnnualWage = Object.entries(
      this.productivity.annualWage
    ).map(([name, data]) => ({ name, dates: data }));
    averageAnnualWage.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    averageAnnualWage.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_average_annual_wage.push(r);
    });
    this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let rentPerEmployee = Object.entries(
      this.productivity.rent
    ).map(([name, data]) => ({ name, dates: data }));
    rentPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    rentPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_rent_per_employee.push(r);
    });
    this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let startupPerformance = Object.entries(this.startupPerformance).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupPerformance.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupPerformance.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let startupRates = Object.entries(this.startupRates).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let cessationRates = Object.entries(this.cessation).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    cessationRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_cessation_info.push(r);
    });
    let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));

    ownerShip.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_ownership_info.push(r);
    });

    let demographicInfo = Object.entries(this.demographics).map(
      ([table, data]) => ({
        name: table,
        data: Object.values(data),
      })
    );
    demographicInfo.forEach((element, index) => {
      this.filtered_demographic_info[index] = [];
      this.filtered_demographic_info[index].push([element.name]);
      element.data.forEach((el, i) => {
        Object.keys(el).forEach((key) => {
          let a = el[key];
          a = a.map((e) => {
            if (typeof e === 'string' && e.includes(',')) {
              return me.numberWithPoints(e);
            } else {
              return e;
            }
          });
          if (!a.includes(key)) {
            a.unshift(key);
          }
          this.filtered_demographic_info[index].push(a);
        });
      });
    });
    let covidData = this.covidColumns.map((name, index) => ({
      name,
      dates: Object.values(this.covid).map((item) => item[index]),
    }));
    covidData.map((item) => {
      item.dates = item.dates.map((e) => {
        if (typeof e === 'string' && e.includes(',')) {
          return me.numberWithPoints(e);
        } else {
          return e;
        }
      });
      return item;
    });
    let covidKeys = Object.keys(this.covid);
    covidKeys.forEach((element, index) => {
      let b = [];
      covidData.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_covid_info.push(b);
    });

    let covidChangedData = this.covidChangeColumns.map((name, index) => ({
      name,
      dates: Object.values(this.covidChange).map((item) => item[index]),
    }));
    covidChangedData.map((item) => {
      item.dates = item.dates.map((e) => {
        if (typeof e === 'string' && e.includes(',')) {
          return me.numberWithPoints(e);
        } else {
          return e;
        }
      });
      return item;
    });
    let covidChangedKeys = Object.keys(this.covid);
    covidChangedKeys.forEach((element, index) => {
      let b = [];
      covidChangedData.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_covid_change_info.push(b);
    });

    this.checkAlreadyAdded3RingAnalysis()

  },
  watch: {
    addressModel() {
      this.allRingAnalysisFieldsFilled = this.check3RingAnalysisFields();
    },
    zipCodeModel() {
      this.allRingAnalysisFieldsFilled = this.check3RingAnalysisFields();
    },
    radius1Model() {
      this.allRingAnalysisFieldsFilled = this.check3RingAnalysisFields();
    },
    radius2Model() {
      this.allRingAnalysisFieldsFilled = this.check3RingAnalysisFields();
    },
    radius3Model() {
      this.allRingAnalysisFieldsFilled = this.check3RingAnalysisFields();
    },
    demog_3ring() {
      this.checkAlreadyAdded3RingAnalysis();
    }
  },
  methods: {

    download3ring() {
      let data = {};
      data.data = {};
      data.data.demographics = this.demographics;
      data.demog_3ring = this.demog_3ring;

      data.type = '3ring';
      this.$store.dispatch('pdf/download', data).then(async (res) => {
        this.pdfGenerating = false;

        if(res.pdf_success) {
          window.open(res.pdf_data, '_blank');
        }
      });
    },

    check3RingAnalysisFields() {
      if (this.radius1Model === null ||
        this.radius1Model > 100 ||
        this.zipCodeModel === null ||
        this.addressModel === null)
        return false

      return true;
    },
    makeDemogTable() {
      let auxObject = null;

      if (this.demog_3ring[Object.keys(this.demog_3ring)[0]])
        auxObject = this.demog_3ring[Object.keys(this.demog_3ring)[0]];

      else if (this.demog_3ring[Object.keys(this.demog_3ring)[1]])
        auxObject = this.demog_3ring[Object.keys(this.demog_3ring)[1]];

      else if (this.demog_3ring[Object.keys(this.demog_3ring)[2]])
        auxObject = this.demog_3ring[Object.keys(this.demog_3ring)[2]];

      let dataFirstElement = auxObject.data;

      let auxArray = [];

      Object.keys(dataFirstElement).forEach(function (key) {
        if (!key.includes('Percent')) {
          const [title, ...columnArray] = key.split(/(?=[A-Z0-9])/)
          const column = columnArray.join("");
          let auxObject = {
            'title': title.toUpperCase(),
            'value': key,
            'label': this.checkTitle(this.formatLabelToDemoTable(column).trim()),
          }

          auxArray.push(auxObject);
        }
      }.bind(this));

      let groupedData = auxArray.reduce(function (r, a) {
        r[a.title] = r[a.title] || [];
        r[a.title].push(a);
        return r;
      }, Object.create(null));
      this.tableDemog3Ring = groupedData;

      this.addMarketFields();





      Object.values(this.demog_3ring).forEach(function (el, ind) {
        let auxArray = [];

        Object.entries(el.data).forEach(([key, value], index) => {

          const [title, ...columnArray] = key.split(/(?=[A-Z0-9])/)
          var column = columnArray.join("");
          if (key == 'meanHHIncome' || key == 'occupiedHousingUnits' || key == 'occupiedHousingUnitsPercent')
            column = key;

          auxArray[this.checkTitle(this.formatLabelToDemoTable(column).trim())] = value;
        })
        this.newDemog3Ring[ind] = auxArray;
      }.bind(this))
    },
    addMarketFields() {
      let plus85 = {
        'title': 'AGE',
        'value': '85plusYears',
        'label': '85plus Years',
      }
      this.tableDemog3Ring.AGE.push(plus85);
    },
    formatLabelToDemoTable(string) {

      let auxStringReplace = string.replace('_', '-');

      let auxStringUpperCase = this.UpperCaseFirstLetter(auxStringReplace);

      const auxStringJoined = auxStringUpperCase.split(/(?=[A-Z])/).join(" ");
      let auxString = auxStringJoined;
      if (isNaN(auxStringJoined.charAt(0))) {
        const [firstElement, ...secondElement] = auxStringJoined.split(/(?=[0-9])/)
        auxString = firstElement + " " + secondElement.join("");
      }
      let label = auxString;
      return label;
    },
    UpperCaseFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.substr(1);
    },
    makeAreaTable() {
      let marketAreaArray = [];

      Object.entries(this.demographics).forEach(entry => {
        const [key, value] = entry;
        Object.entries(value).forEach(entryAux => {
          Object.entries(entryAux[1]).forEach(elem => {
            let auxObject = {
              'title': this.checkTitle(elem[0]),
              'value': elem[1],
            }
            marketAreaArray.push(auxObject);
          })
        })
      });

      let groupedData = marketAreaArray.reduce(function (r, a) {
        r[a.title] = r[a.title] || [];
        r[a.title].push(a);
        return r;
      }, Object.create(null));
      this.newMarketAreaData = groupedData;

    },
    checkTitle(title) {
      switch (title) {
        case '2-plus Races':
          return '2 Plus Races';
        case '85-plus Years':
          return '85plus Years';

        case '$10k-14.9k Income':
          //case '10k14-9k':
          return '10k14-9k';

        case '$15k-24.9k Income':
          //case '15k24-9k':
          return '15k24-9k';

        case '$25k-34.9k Income':
          //case '25k34-9k':
          return '25k34-9k';

        case '$35k-49.9k Income':
          //case '35k49-9k':
          return '35k49-9k';

        case '$50k-74.9k Income':
          //case '50k74-9k':
          return '50k74-9k';

        case '$75k-99.9k Income':
          //case '75k99-9k':
          return '75k99-9k';

        case '$100k-149.9k Income':
          //case '100k149-9k':
          return '100k149-9k';

        case '$150k-199.9k Income':
          //case '150k199-9k':
          return '150k199-9k';

        case '150k199-9k':
          return '150k199-9k';

        case 'Below $10k Income':
          return 'Below 10k';

        case '>$200k Income':
          return 'Over 200k';

        case 'School Graduateor Higher':
          //case 'School Graduateor Higher':
          return '% High School Graduate or Higher (total)';

        case 'School Graduateor Higher Percent':
          return '% High School Graduate or Higher (total) Percent';

        case "Degreeor Higher":
          //case "Degreeor Higher":
          return "% Bachelor's Degree or Higher (total)";

        case "Degreeor Higher Percent":
          //case "Degreeor Higher":
          return "% Bachelor's Degree or Higher (total) Percent";


        case "Hispanic (all races)":
          return 'Hispanic';

        /*case "Commute 15-29 Minutes":
        //case "15to29":
          return '15-29';
        case "Commute 30-44 Minutes":
        //case "30to44":
          return '30-44';
        case "Commute 45-89 Minutes":
        //case "45to89":
          return '45-89';
            */
        case "Commute < 15 Minutes":
          return 'Less Than 14';

        case "Commute > 90 Minutes":
          return '90 Plus';

        case "Rent Paid 15%-19.9% of Income (Households)":
        case "Paid 15-19_9of Income":
          return 'Paid 15%-19.9% of Income';

        case "Rent Paid 15%-19.9% of Income (Households) Percent":
        case "Paid 15-19_9of Income Percent":
          return 'Paid 15%-19.9% of Income Percent';

        case "Rent Paid 20%-24.9% of Income (Households)":
        case "Paid 20-24_9of Income":
          return 'Paid 20%-24.9% of Income';

        case "Rent Paid 20%-24.9% of Income (Households) Percent":
        case "Paid 20-24_9of Income Percent":
          return 'Paid 20%-24.9% of Income Percent';

        case "Rent Paid 25%-29.9% of Income (Households)":
        case "Paid 25-29_9of Income":
          return 'Paid 25%-29.9% of Income';

        case "Rent Paid 25%-29.9% of Income (Households) Percent":
        case "Paid 25-29_9of Income Percent":
          return 'Paid 25%-29.9% of Income Percent';

        case "Rent Paid 30%-34.9% of Income (Households)":
        case "Paid 30-34_9of Income":
          return 'Paid 30%-34.9% of Income';

        case "Rent Paid 30%-34.9% of Income (Households) Percent":
        case "Paid 30-34_9of Income Percent":
          return 'Paid 30%-34.9% of Income Percent';

        case "Rent Paid 35%-plus of Income (Households)":
        case "Paid 35 Plusof Income":
          return 'Paid 35 Plus of Income';

        case "Rent Paid 35%-plus of Income (Households) Percent":
        case "Paid 35 Plusof Income Percent":
          return 'Paid 35 Plus of Income Percent';

        case "Rent Paid < 15% of Income (Households)":
        case "Paid Less Than 15of Income":
          return 'Paid Less Than 15% of Income';

        case "Rent Paid < 15% of Income (Households) Percent":
        case "Paid Less Than 15of Income Percent":
          return 'Paid Less Than 15% of Income Percent';

        case "Owner Occupied Units: Value $50k-$99.9k":
        case "Occupied Units Value 50k99-9k":
          return 'Occupied Units Value 50k-99.9k';

        case "Owner Occupied Units: Value $100k-$149.9k":
        case "Occupied Units Value 100k-149_9k":
          return 'Occupied Units Value 100k-149.9k';

        case "Owner Occupied Units: Value $150k-$199.9k":
        case "Occupied Units Value 150k-199_9k":
          return 'Occupied Units Value 150k-199.9k';

        case "Owner Occupied Units: Value $200k-$299.9k":
        case "Occupied Units Value 200k-299_9k":
          return 'Occupied Units Value 200k-299.9k';

        case "Owner Occupied Units: Value $300k-$499.9k":
        case "Occupied Units Value 300k-499_9k":
          return 'Occupied Units Value 300k-499.9k';

        case "Owner Occupied Units: Value $500k-$999.9k":
        case "Occupied Units Value 500k-999_9k":
          return 'Occupied Units Value 500k-999.9k';

        case "Owner Occupied Units: Value < $50k":
          return 'Occupied Units Value Less Than 50k';

        case "Owner Occupied Units: Value >$1 Million":
        case "Occupied Units Value O Ver 1 Million":
          return 'Occupied Units Value Over 1 Million';

        case "Owner-Occupied Units with Mortgage":
        case "Occupied Unitswith Mortgage":
          return 'Occupied Units with Mortgage';

        case "Owner-Occupied Units without Mortgage":
        case "Occupied Unitswithout Mortgage":
          return 'Occupied Units without Mortgage';

        case "Owner Occupied Units: Value $50k-$99.9k Percent":
        case "Occupied Units Value 50k99-9k Percent":
          return 'Occupied Units Value 50k-99.9k Percent';

        case "Owner Occupied Units: Value $100k-$149.9k Percent":
        case "Occupied Units Value 100k-149_9k Percent":
          return 'Occupied Units Value 100k-149.9k Percent';

        case "Owner Occupied Units: Value $150k-$199.9k Percent":
        case "Occupied Units Value 150k-199_9k Percent":
          return 'Occupied Units Value 150k-199.9k Percent';

        case "Owner Occupied Units: Value $200k-$299.9k Percent":
        case "Occupied Units Value 200k-299_9k Percent":
          return 'Occupied Units Value 200k-299.9k Percent';

        case "Owner Occupied Units: Value $300k-$499.9k Percent":
        case "Occupied Units Value 300k-499_9k Percent":
          return 'Occupied Units Value 300k-499.9k Percent';

        case "Owner Occupied Units: Value $500k-$999.9k Percent":
        case "Occupied Units Value 500k-999_9k Percent":
          return 'Occupied Units Value 500k-999.9k Percent';

        case "Owner Occupied Units: Value < $50k Percent":
          return 'Occupied Units Value Less Than 50k Percent';

        case "Owner Occupied Units: Value >$1 Million Percent":
        case "Occupied Units Value O Ver 1 Million Percent":
          return 'Occupied Units Value Over 1 Million Percent';

        case "Owner-Occupied Units with Mortgage Percent":
        case "Occupied Unitswith Mortgage Percent":
          return 'Occupied Units with Mortgage Percent';

        case "Owner-Occupied Units without Mortgage Percent":
        case "Occupied Unitswithout Mortgage Percent":
          return 'Occupied Units without Mortgage Percent';


        case "Housing Built 1940-1949":
          return 'Built 1940-1949';

        case "Housing Built 1950-1959":
          return 'Built 1950-1959';

        case "Housing Built 1960-1969":
          return 'Built 1960-1969';

        case "Housing Built 1970-1979":
          return 'Built 1970-1979';

        case "Housing Built 1980-1989":
          return 'Built 1980-1989';

        case "Housing Built 1990-1999":
          return 'Built 1990-1999';

        case "Housing Built 2000-2009":
          return 'Built 2000-2009';

        case "Units with 1.1-1.5 Occupants Per Room":
        case "1-1_1_5 Occupants Per Room":
          return '1.1-1.5 Occupants Per Room';

        case "Units with 1.51-plus Occupants Per Room":
        case "1-51_plus Occupants Per Room":
          return '15-51 Plus Occupants Per Room';

        case "Units with less than 1 Occupant Per Room":
          return 'With Less Than 1 Occupant Per Room';

        case "Occupied Units Paying Rent":
          return 'Units Paying Rent';

        case "Occupied Units Paying <$500 Rent":
          return 'Units Paying Less Than 500 Rent';

        case "Occupied Units Paying $3000 or More Rent":
          return 'Units Paying 3000 Plus';

        case "Occupied Units Paying $2500-$3000 Rent":
          return 'Units Paying 2500-2999';

        case "Occupied Units Paying $2000-$2499 Rent":
          return 'Units Paying 2000-2499';

        case "Occupied Units Paying $1500-$1999 Rent":
          return 'Units Paying 1500-1999';

        case "Occupied Units Paying $1000-$1499 Rent":
          return 'Units Paying 1000-1499';

        case "Occupied Units Paying $500-$999 Rent":
          return 'Units Paying 500-9999';

        /*case "Occupied Housing Units":
          return 'Housing Units';
*/
        case "Mobile Home Housing Units":
          return 'Home Housing Units';

        case "Boat-RV-Van Housing Units":
          return 'R V Van Housing Units';


        case "Some College/Associate's Degree":
          return 'College Or Associates Degree';

        case "Bachelor's degree":
          return 'Degree';

        case "Graduate/Professional degree":
          return 'Professional Degree';

        case "High School Graduate":
          return 'School Graduate';

        case "Per Capita Income ($)":
          return 'Capita Income';

        case "Total Commuters":
          return 'Commuters';

        case "Total households":
          return 'Households';

        case "Work at Home":
          return 'At Home';

        case "Civilian Labor Force":
          return 'Labor Force';

        case "Civilian employment":
          return 'Employment';

        case "":
          return 'Unemployed';

        case "Labor force":
          return 'Force';

        case "Median Value of Owner Occupied Units":
          //case "Valueof Owner Occupied Units":
          return 'Value of Owner Occupied Units';

        case "Valueof Owner Occupied Units Temp":
          return 'Value of Owner Occupied Units Temp';

        case "Median Age":
          return 'Age';

        case "Median Rent Paid":
          return 'Rent Paid';

        /*case "Mean HH Income ($)":
          return 'H H Income';
*/
        case "Female":
          return 'Total Female';
        case "Male":
          return 'Total Male';
        case "Population 25+ Years":
          return '25 Plus Years';
        case "Population: 16-plus Years":
          return '16 Plus Years';
        case "Total population":
          return 'Total';


        case "Percent":
          return 'Unemployed Percent';

        case "15to29":
          return 'Commute 15-29 Minutes';

        case "30to44":
          return 'Commute 30-44 Minutes';

        case "45to89":
          return 'Commute 45-89 Minutes';

        case "15to29 Percent":
          return 'Commute 15-29 Minutes Percent';

        case "30to44 Percent":
          return 'Commute 30-44 Minutes Percent';

        case "45to89 Percent":
          return 'Commute 45-89 Minutes Percent';

        case "Mean H H Income":
          return 'Mean HH Income ($)';

        case "Mean H H Income Percent":
          return 'Mean HH Income ($) Percent';

        case "H H Income":
          return 'Median HH Income ($)';

        case "H H Income Percent":
          return 'Median HH Income ($) Percent'

        case "Housing Units":
          return 'Total Housing Units'

        case "Housing Units Percent":
          return 'Total Housing Units Percent'

        case "Built 2010or Later":
          return 'Housing Built 2010 or Later';

        case "Built 2010or Later Percent":
          return 'Housing Built 2010 or Later Percent';

        case "Built 1939or Before":
          return 'Housing Built 1939 or Before';

        case "Built 1939or Before Percent":
          return 'Housing Built 1939 or Before Percent';

        case "Units with 1.1-1.5 Occupants Per Room Percent":
        case "1-1_1_5 Occupants Per Room Percent":
          return '1.1-1.5 Occupants Per Room Percent';

        case "Units with 1.51-plus Occupants Per Room Percent":
        case "1-51_plus Occupants Per Room Percent":
          return '15-51 Plus Occupants Per Room Percent';


        case "Valueof Owner Occupied Units":
          return 'Median Value of Owner Occupied Units ($)';

        default:
          return title;
      }
    },
    checkAlreadyAdded3RingAnalysis() {
      if (this.demog_3ring && Object.entries(this.demog_3ring).length !== 0) {

        this.isRingAnalysis = false;
        this.makeDemogTable();
        this.makeAreaTable();

      }
      else
        this.isRingAnalysis = true;
    },
    async analysis() {

      if (this.allRingAnalysisFieldsFilled) {
        let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
        );

        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + '/user/report/save_demographics',
            {},
            {
              params: {
                session_id: currentSession,
                product_id: this.$route.params.id,
                address: this.addressModel,
                zip: this.zipCodeModel,
                radius_1: this.radius1Model,
                radius_2: this.radius2Model,
                radius_3: this.radius3Model,
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/report/save_demographics" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }

            this.$router.push({
              name: "MarketAboutTheData",
              params: this.$route.params.id,
            });
            this.$router.go()
          });
      }
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if (typeof x === 'string') {
        return x.replace(/,/g, '.');
      } else {
        return x;
      }

    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Market Profile.csv';
      anchor.click();
    },
  },
};
</script>

<style lang="scss">
.demographics-button {
  display: flex;
  justify-content: flex-end;
}

.collapse_table {
  &:not(:last-of-type) {
    margin-bottom: 30px;
  }
}
</style>
